(function() {
  'use strict';

  const BUNDLE_PROPERTY = '_bundle_item';
  const BUNDLE_ID_PROPERTY = '_bundle_id';

  class BundleBuilder {
    constructor(container) {
      this.container = container;
      this.selectedItems = new Map();
      this.tier1Qty = parseInt(container.dataset.tier1Qty) || 3;
      this.tier1Discount = parseInt(container.dataset.tier1Discount) || 5;
      this.tier2Qty = parseInt(container.dataset.tier2Qty) || 4;
      this.tier2Discount = parseInt(container.dataset.tier2Discount) || 10;

      this.summaryEl = document.getElementById('bundle-summary');
      this.thumbsEl = document.getElementById('bundle-thumbs');
      this.countEl = document.getElementById('bundle-count');
      this.discountLabelEl = document.getElementById('bundle-discount-label');
      this.originalPriceEl = document.getElementById('bundle-original-price');
      this.finalPriceEl = document.getElementById('bundle-final-price');
      this.savingsEl = document.getElementById('bundle-savings');
      this.addBtn = document.getElementById('bundle-add-to-cart');
      this.progressBar = document.getElementById('bundle-progress-bar');

      this.bindEvents();
    }

    bindEvents() {
      // Product select buttons
      this.container.querySelectorAll('.bundle-product-card__select-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const card = btn.closest('.bundle-product-card');
          this.toggleProduct(card);
        });
      });

      // Variant selectors
      this.container.querySelectorAll('.bundle-variant-select').forEach(select => {
        select.addEventListener('change', (e) => {
          const card = select.closest('.bundle-product-card');
          const selectedOption = select.options[select.selectedIndex];
          card.dataset.variantId = select.value;
          card.dataset.productPrice = selectedOption.dataset.price;

          // Update price display
          const priceEl = card.querySelector('.bundle-product-card__price');
          if (priceEl) {
            priceEl.textContent = this.formatMoney(parseInt(selectedOption.dataset.price));
          }

          // Re-calculate if already selected
          if (this.selectedItems.has(card.dataset.productId)) {
            this.selectedItems.set(card.dataset.productId, {
              variantId: select.value,
              price: parseInt(selectedOption.dataset.price),
              title: card.dataset.productTitle,
              image: card.dataset.productImage,
              handle: card.dataset.productHandle
            });
            this.updateSummary();
          }
        });
      });

      // Filter buttons
      this.container.querySelectorAll('.bundle-filter-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          this.filterProducts(btn.dataset.filter);
          this.container.querySelectorAll('.bundle-filter-btn').forEach(b => b.classList.remove('bundle-filter-btn--active'));
          btn.classList.add('bundle-filter-btn--active');
        });
      });

      // Add to cart button
      if (this.addBtn) {
        this.addBtn.addEventListener('click', () => this.addBundleToCart());
      }
    }

    toggleProduct(card) {
      const productId = card.dataset.productId;

      if (this.selectedItems.has(productId)) {
        this.selectedItems.delete(productId);
        card.classList.remove('bundle-product-card--selected');
      } else {
        this.selectedItems.set(productId, {
          variantId: card.dataset.variantId,
          price: parseInt(card.dataset.productPrice),
          title: card.dataset.productTitle,
          image: card.dataset.productImage,
          handle: card.dataset.productHandle
        });
        card.classList.add('bundle-product-card--selected');
      }

      this.updateSummary();
    }

    getCurrentDiscount() {
      const count = this.selectedItems.size;
      if (count >= this.tier2Qty) return this.tier2Discount;
      if (count >= this.tier1Qty) return this.tier1Discount;
      return 0;
    }

    getNextTier() {
      const count = this.selectedItems.size;
      if (count < this.tier1Qty) return { needed: this.tier1Qty - count, discount: this.tier1Discount };
      if (count < this.tier2Qty) return { needed: this.tier2Qty - count, discount: this.tier2Discount };
      return null;
    }

    getTotalPrice() {
      let total = 0;
      this.selectedItems.forEach(item => { total += item.price; });
      return total;
    }

    updateSummary() {
      const count = this.selectedItems.size;
      const discount = this.getCurrentDiscount();
      const total = this.getTotalPrice();
      const discountedTotal = Math.round(total * (1 - discount / 100));
      const savings = total - discountedTotal;
      const nextTier = this.getNextTier();

      // Show/hide summary bar
      if (count > 0) {
        this.summaryEl.style.display = 'block';
        setTimeout(() => this.summaryEl.classList.add('bundle-summary--visible'), 10);
      } else {
        this.summaryEl.classList.remove('bundle-summary--visible');
        setTimeout(() => { this.summaryEl.style.display = 'none'; }, 300);
      }

      // Update count
      this.countEl.textContent = count + (count === 1 ? ' item' : ' items') + ' selected';

      // Update discount label
      if (discount > 0) {
        this.discountLabelEl.textContent = discount + '% off applied!';
        this.discountLabelEl.classList.add('bundle-summary__discount--active');
      } else {
        this.discountLabelEl.textContent = '';
        this.discountLabelEl.classList.remove('bundle-summary__discount--active');
      }

      // Update prices
      if (count > 0) {
        this.originalPriceEl.textContent = this.formatMoney(total);
        if (discount > 0) {
          this.originalPriceEl.classList.add('bundle-summary__original-price--struck');
          this.finalPriceEl.textContent = this.formatMoney(discountedTotal);
          this.savingsEl.textContent = 'You save ' + this.formatMoney(savings);
          this.savingsEl.style.display = 'block';
        } else {
          this.originalPriceEl.classList.remove('bundle-summary__original-price--struck');
          this.finalPriceEl.textContent = '';
          this.savingsEl.style.display = 'none';
        }
      }

      // Update thumbnails
      this.thumbsEl.innerHTML = '';
      this.selectedItems.forEach((item, id) => {
        const thumb = document.createElement('div');
        thumb.className = 'bundle-summary__thumb';
        thumb.innerHTML = '<img src="' + item.image + '" alt="' + item.title + '" width="48" height="48">';
        this.thumbsEl.appendChild(thumb);
      });

      // Update button state
      if (discount > 0) {
        this.addBtn.disabled = false;
        this.addBtn.querySelector('.bundle-summary__add-text').textContent = 'Add Bundle to Cart — ' + this.formatMoney(discountedTotal);
      } else if (nextTier) {
        this.addBtn.disabled = count === 0;
        if (count === 0) {
          this.addBtn.querySelector('.bundle-summary__add-text').textContent = 'Select ' + this.tier1Qty + ' items to unlock ' + this.tier1Discount + '% off';
        } else {
          this.addBtn.querySelector('.bundle-summary__add-text').textContent = 'Add ' + nextTier.needed + ' more for ' + nextTier.discount + '% off';
          this.addBtn.disabled = false;
        }
      }

      // Update progress bar
      const maxQty = this.tier2Qty;
      const progress = Math.min((count / maxQty) * 100, 100);
      this.progressBar.style.width = progress + '%';

      if (discount >= this.tier2Discount) {
        this.progressBar.classList.add('bundle-progress__bar--max');
      } else if (discount > 0) {
        this.progressBar.classList.remove('bundle-progress__bar--max');
        this.progressBar.classList.add('bundle-progress__bar--tier1');
      } else {
        this.progressBar.classList.remove('bundle-progress__bar--max', 'bundle-progress__bar--tier1');
      }
    }

    filterProducts(handle) {
      const cards = this.container.querySelectorAll('.bundle-product-card');
      cards.forEach(card => {
        if (handle === 'all') {
          card.style.display = '';
        } else {
          const collections = card.dataset.collections.split(',');
          card.style.display = collections.includes(handle) ? '' : 'none';
        }
      });
    }

    async addBundleToCart() {
      const btn = this.addBtn;
      const btnText = btn.querySelector('.bundle-summary__add-text');
      const originalText = btnText.textContent;

      btn.disabled = true;
      btnText.textContent = 'Adding to cart...';

      const bundleId = 'bundle_' + Date.now();
      const discount = this.getCurrentDiscount();
      const items = [];

      this.selectedItems.forEach((item, productId) => {
        items.push({
          id: parseInt(item.variantId),
          quantity: 1,
          properties: {
            [BUNDLE_PROPERTY]: 'true',
            [BUNDLE_ID_PROPERTY]: bundleId,
            '_bundle_discount': discount + '%',
            '_bundle_size': this.selectedItems.size.toString()
          }
        });
      });

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });

        if (!response.ok) throw new Error('Failed to add to cart');

        // Apply discount code silently if applicable
        if (discount > 0) {
          const discountCode = discount === this.tier2Discount ? 'BUNDLE' + this.tier2Discount : 'BUNDLE' + this.tier1Discount;
          await fetch('/discount/' + discountCode, { method: 'GET', redirect: 'manual' }).catch(() => {});
        }

        btnText.textContent = 'Added to cart!';
        btn.classList.add('bundle-summary__add-btn--success');

        // Update cart count in header
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));

        // Open the drawer cart by clicking the cart icon
        setTimeout(() => {
          var cartIcon = document.querySelector('[data-js-cart-icon], a[href="/cart"]');
          if (cartIcon) {
            cartIcon.click();
          }

          btnText.textContent = originalText;
          btn.classList.remove('bundle-summary__add-btn--success');
          btn.disabled = false;
        }, 500);

      } catch (err) {
        console.error('Bundle add to cart error:', err);
        btnText.textContent = 'Error — try again';
        setTimeout(() => {
          btnText.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      }
    }

    formatMoney(cents) {
      const amount = (cents / 100).toFixed(2);
      return '$' + amount;
    }
  }

  // Initialize
  document.addEventListener('DOMContentLoaded', function() {
    const container = document.querySelector('.bundle-builder');
    if (container) {
      new BundleBuilder(container);
    }
  });

  // Also handle Shopify section rendering
  document.addEventListener('shopify:section:load', function(e) {
    const container = e.target.querySelector('.bundle-builder');
    if (container) {
      new BundleBuilder(container);
    }
  });
})();
